module.exports = __webpack_public_path__ + "img/eswar-logo-extended-3-resized.42691df5.png";